import React from "react"
import { Navigate, useLocation } from "react-router-dom"

const routeTitles = {
  "/waitlist": "Join Our Waitlist",
  "/sparc": "SPARC Integration",
  "/campminder": "Campminder Integration",
  "/msm": "MSM Integration",
  "/tri-state-26": "ACA Tri-State 2026 Special Offer"
}

const routeLeadSources = {
  "/waitlist": "TCS Website",
  "/sparc": "SPARC",
  "/campminder": "Campminder",
  "/msm": "MSM",
  "/tri-state-26": "Tri-State 2026"
}

const routeFooters = {
  "/tri-state-26": "$750 setup fee and $125/month for your first workflow. Offer ends June 1, 2026"
}

const RedirectToStart = () => {
  const location = useLocation()
  const incomingState = location.state && typeof location.state === "object" ? location.state : {}
  const targetPath = `${process.env.PUBLIC_URL || ""}/start`

  const title = routeTitles[location.pathname] || "Learn More"
  const footerText = routeFooters[location.pathname]

  return (
    <Navigate
      to={targetPath}
      replace
      state={{ ...incomingState, leadSource: routeLeadSources[location.pathname] || "TCS Website", title, footerText }}
    />
  )
}

export default RedirectToStart
